export default __webpack_public_path__ + "static/media/freshworks.4042caa1.jpg";